import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiHome,
  FiUserPlus,
  FiFileText,
  FiLogOut,
  FiX
} from "react-icons/fi";
import sidebarlogo from "../assets/sidebarlogo.png";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";

  // Check screen size on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
      // Auto-close sidebar on mobile when resizing to desktop
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, [setSidebarOpen]);

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate(isAdmin ? "/login" : "/employee-login");
    }
  }, [isAuthenticated, navigate, isAdmin]);

  const handleLogout = () => {
    // Show success toast
    toast.success("Logged out successfully!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    
    // Add a small delay to allow the toast to be seen before redirecting
    setTimeout(() => {
      sessionStorage.clear();
      navigate(isAdmin ? "/login" : "/employee-login");
    }, 500);
  };

  if (!isAuthenticated) return null;

  const menuItems = [
    {
      path: "/dashboard",
      name: isAdmin ? "Dashboard" : "Student Enrollment",
      icon: <FiHome className="w-5 h-5" />
    },
    isAdmin && {
      path: "/employee-information",
      name: "Create Voluntary",
      icon: <FiUserPlus className="w-5 h-5" />
    },
    isAdmin && {
      path: "/employee-reports",
      name: "Voluntary Reports",
      icon: <FiFileText className="w-5 h-5" />
    },
    {
      path: "/student-reports",
      name: "Students Report",
      icon: <FiFileText className="w-5 h-5" />
    }
  ].filter(Boolean);

  return (
    <>
      {/* Mobile menu button - always visible on mobile */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="fixed z-20 top-4 left-4 p-2 text-gray-500 focus:outline-none lg:hidden"
          aria-label="Toggle sidebar"
        >
          <FiMenu className="w-6 h-6" />
        </button>
      )}

      {/* Mobile Sidebar Backdrop */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed z-30 ${
          sidebarOpen ? "w-80" : "w-20"
        } bg-white shadow-md h-screen flex flex-col justify-between transition-all duration-300 ease-in-out ${
          isMobile && !sidebarOpen ? "-translate-x-full" : "translate-x-0"
        } lg:translate-x-0`}
      >
        {/* Top bar with logo and menu toggle */}
        <div>
          <div className="p-4 border-b flex items-center justify-between">
            <div className="flex items-center gap-2">
              {!isMobile && (
                <button
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                  className="text-gray-500 focus:outline-none"
                  aria-label="Toggle sidebar"
                >
                  {sidebarOpen ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
                </button>
              )}

{sidebarOpen && (
  <a href="/dashboard">
    <img
      src={sidebarlogo}
      alt="Logo"
      className="h-20 object-contain ml-1"
    />
  </a>
)}
            </div>
          </div>

          {/* Menu List */}
          <nav className="p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => {
                      if (isMobile) setSidebarOpen(false);
                    }}
                    className={`flex items-center p-2 rounded-lg ${
                      location.pathname === item.path
                        ? "bg-blue-100 text-blue-600"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                    title={!sidebarOpen ? item.name : ""}
                  >
                    <span className="mr-3">{item.icon}</span>
                    {sidebarOpen && <span>{item.name}</span>}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Logout */}
        <div className="p-4 border-t">
          <button
            onClick={handleLogout}
            className="flex items-center w-full text-left text-gray-600 hover:bg-gray-100 p-2 rounded-lg"
            title={!sidebarOpen ? "Logout" : ""}
          >
            <FiLogOut className="w-5 h-5 mr-3" />
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;